import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Status } from '../interfaces/status';

@Injectable()
export class StatusService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.STATUS_API_URL}`;
  }

  getStatuses(): Observable<Status[]> {
    return this.http.get<Status[]>(this.url);
  }

  getStatusesWithEditPermForRoles(roles: string[]): Observable<Status[]> {
    const queryParams = new HttpParams().set(
      'filter',
      JSON.stringify({
        rolesAllowedToEditItemsAtThisStatus: { $in: roles }
      })
    );
    return this.http.get<Status[]>(this.url, { params: queryParams });
  }

  getStatusById(id: string): Observable<Status> {
    return this.http.get<Status>(`${this.url}/${id}`);
  }

  createStatus(product: Status): Observable<Status> {
    return this.http.post<Status>(this.url, product);
  }

  updateStatus(id: string, product: Status): Observable<Status> {
    return this.http.put<Status>(`${this.url}/${id}`, product);
  }

  deleteStatus(id: string): Observable<Status> {
    return this.http.delete<Status>(`${this.url}/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/status.service.ts